var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoxChecked = function SvgBoxChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60802 8.08154L14.8988 0.990167C16.0319 0.336611 17.4242 0.336611 18.5572 0.990167L30.848 8.08154C31.0564 8.20109 31.0261 8.49464 30.8094 8.59827L17.1838 15.1141C16.8956 15.2519 16.5605 15.2519 16.2722 15.1141L2.64663 8.59827C2.42994 8.49464 2.3997 8.20109 2.60802 8.08154ZM17.9571 18.1565C17.9571 17.7496 18.1908 17.3789 18.5578 17.2034L32.3228 10.6206C32.4714 10.5495 32.6476 10.6353 32.6709 10.7984C32.6941 10.968 32.7061 11.1401 32.7061 11.3138V25.406C32.7061 26.7422 31.9971 27.9758 30.848 28.6383L30.2835 28.964C30.0625 28.8729 29.8505 28.7504 29.6541 28.5959C27.5317 26.9273 24.5635 29.1252 25.5404 31.6421L25.5589 31.6899L18.5572 35.7296C18.2777 35.8906 17.9571 35.6674 17.9571 35.3448V18.1565ZM15.499 18.1565C15.499 17.7496 15.2653 17.3789 14.8982 17.2034L1.59969 10.8436C1.21213 10.6583 0.75 10.8842 0.75 11.3138V25.406C0.75 26.7422 1.45896 27.9758 2.60802 28.6383L14.8988 35.7296C15.1783 35.8906 15.499 35.6674 15.499 35.3448V18.1565Z",
    fill: "#01cdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0734 28.5793L32.6973 35.9713L29.0092 32.2753",
    stroke: "#01cdfb",
    strokeWidth: 2.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BoxChecked.8df1fe25.svg";
export { ForwardRef as ReactComponent };